// extracted by mini-css-extract-plugin
module.exports = {"loadWrapper":"Loading_loadWrapper__2JozP","load":"Loading_load__11HE2","ring":"Loading_ring__3auns","loading":"Loading_loading__38WPi"};